import type { ComponentStyleConfig } from "@chakra-ui/theme";
import { colors } from "../../colors";

export const Heading: ComponentStyleConfig = {
	baseStyle: {
		fontWeight: 300,
		color: colors.text.dark,
		fontFamily: ["SF Pro", "Roboto"],
	},
	sizes: {
		xl: {
			fontSize: {
				base: "3xl",
				lg: "5xl",
			},
		},
		lg: {
			fontSize: {
				base: "2xl",
				lg: "4xl",
			},
		},
		md: {
			fontSize: {
				base: "xl",
				lg: "3xl",
			},
		},
		sm: {
			fontSize: {
				base: "lg",
				lg: "2xl",
			},
		},
		exll: {
			fontSize: {
				base: "3xl",
				lg: "6xl",
			},
		},
		exl: {
			fontSize: {
				base: "2xl",
				lg: "4xl",
			},
		},
	},
};
